import React from "react"
import { useGetValidateData } from "components/Shared/ValidateData/useGetValidateData"
import SwitchingValidateDataSkeleton from "./SwitchingValidateDataSkeleton"
import { RequestHandler } from "components/Shared/RequestHandler"
import { RequestParameters } from "components/Shared/Filters/interfaces"

type SwitchingInputValidatorProps = {
	switchingFilters: RequestParameters
}

const SwitchingValidateData: React.FC<SwitchingInputValidatorProps> = (
	props
) => {
	const { switchingFilters, children } = props
	const {
		data: { hasData } = {},
		error,
		isPendingRequest,
		isError,
		refetch,
	} = useGetValidateData(switchingFilters)

	return (
		<RequestHandler
			hasData={hasData}
			error={error}
			isError={isError}
			isLoading={isPendingRequest}
			retry={refetch}
			skeleton={<SwitchingValidateDataSkeleton />}
		>
			{children}
		</RequestHandler>
	)
}

export default SwitchingValidateData
